
  import React from "react"
  import Component from "/Users/mike/Documents/git/ppcat.github.io/src/layouts/index.js"
  import data from "/Users/mike/Documents/git/ppcat.github.io/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js